import { hideElement, showElement } from '/src/common/js';

const modal = document.getElementById('modal');
const modalBackdrop = modal?.querySelector('.modal__backdrop');
const modalBtnClose = document.querySelector('.modal__btn--close');
const modalBoxForm = document?.querySelector('[data-modalbox="form"]');
const modalBoxMsg = document?.querySelector('[data-modalbox="msg"]');
const formFeedbackModal = document.forms?.formFeedbackModal;

document.addEventListener('click', checkBtnAndPpenModal);

function onBackdropClick(e) {
  if (e.currentTarget === e.target) closeModal();
}
function onEscKeyPress(e) {
  if (modalBackdrop?.classList.contains('isHidden')) return;
  if (e.code === 'Escape') closeModal();
}
export function openModal() {
  modal.style.display = 'flex';
  setTimeout(() => {
    showElement(modal);
    document.body?.classList.add('modalIsOpen');
  }, 10); // Невелика затримка для анімації, можна змінити

  modalBackdrop?.addEventListener('click', onBackdropClick);
  window?.addEventListener('keydown', onEscKeyPress);
  modalBtnClose?.addEventListener('click', closeModal);
}
export function closeModal() {
  hideElement(modal);
  document.body?.classList.remove('modalIsOpen');
  hideElement(modalBoxMsg);
  showElement(modalBoxForm);
  formFeedbackModal?.reset();
  
  modalBackdrop?.removeEventListener('click', onBackdropClick);
  window.removeEventListener('keydown', onEscKeyPress);
  modalBtnClose?.removeEventListener('click', closeModal);
  modal.style.display = 'none'; 
}

function checkBtnAndPpenModal(e) {
  const isBtnAvalible = e.target.hasAttribute('data-cta-btn');
  if (!isBtnAvalible) return;

  openModal();
}
